import { ReactElement, useState, useEffect } from 'react';
import { Field, getIn, useFormikContext } from 'formik';
import { CheckboxInput, TextInput } from '@components';
import gridFormStyles from '@pages/forms/Grid.module.scss';
import EmailIcon from '../../images/email.svg';

interface iProps {
  emailField: string;
  noEmailField: string;
  noEmailFieldRequired?: boolean;
  currentSP: string;
}
const EmailField = ({ emailField, noEmailField, currentSP, noEmailFieldRequired = true }: iProps): ReactElement => {
  const [disableEmailInput, setEmailInput] = useState(false);
  const formikContext = useFormikContext();

  useEffect(() => {
    setEmailInput(getIn(formikContext.values, noEmailField));
  }, []);

  return (
    <div className={gridFormStyles.gridColFull}>
      <Field name={emailField} component={TextInput} title="Email" icon={EmailIcon} disabled={disableEmailInput} isMandatory />
      {noEmailFieldRequired && (
        <Field
          name={noEmailField}
          component={CheckboxInput}
          title={currentSP}
          boxChecked={(e: boolean) => {
            setEmailInput(e);
            formikContext.setFieldTouched(emailField, false);
            formikContext.setFieldValue(emailField, '');
          }}
        />
      )}
    </div>
  );
};

export default EmailField;
